import { styled } from '@material-ui/core';
import DeleteIcon from '@src/resources/icons/DeleteIcon';
import { forwardRef, type HTMLAttributes } from 'react';

const DeleteOutlinedButtonStyled = styled('button')({
  all: 'unset',
  cursor: 'pointer',
  display: 'inline-flex',
  padding: '2px',
  margin: '-2px',
  transition: 'transform 100ms ease-in 0ms',
  '& svg': {
    width: '15px',
    height: '15px',
    backgroundColor: '#FFFFFF88',
    borderRadius: '15px',
  },
  '&:hover': {
    transform: 'scale(1.1)',
  },
});

/**
 * A button component that displays a delete (close) icon.
 *
 * This component forwards its ref to the underlying styled button element.
 * It accepts all standard HTML button attributes via props.
 *
 * @param props - Standard HTML button attributes.
 * @param ref - Ref forwarded to the button element.
 *
 */
const DeleteOutlinedButton = forwardRef<
  HTMLButtonElement,
  HTMLAttributes<HTMLButtonElement>
>((props, ref) => (
  <DeleteOutlinedButtonStyled ref={ref} {...props}>
    <DeleteIcon />
  </DeleteOutlinedButtonStyled>
));

DeleteOutlinedButton.displayName = 'DeleteOutlinedButton';

export default DeleteOutlinedButton;
